export * from "./styles";

export const THEME_VARIANT = {
  DARK: "dark",
  LIGHT: "light",
};

export const TOKEN_STORAGE_KEY = "ac";
export const USER_CONFIG_STORAGE_KEY = "usc";
export const noop = () => {};
export const sessionExpireMsg =
  "Session expired! Redirecting to login screen..";
export const DEFAULT_ERROR_MESSAGE =
  "Something went wrong, please contact system administrator.";

export const PhoneRegexE164 = /^$|^\+\d{11,13}$/;

export const VALIDATIONS = {
  ALPHANUMERIC: "alphanumeric",
  MAX_LENGTH: "maxLength",
  MIN_LENGTH: "minLength",
  MAX: "max",
  MIN: "min",
  INTEGER: "integer",
  FLOAT: "float",
  NUMBER: "number",
  REQUIRED: "required",
  EMAILS: "emails",
  REGEX: "regex",
  PHONE: "phone",
};
export const PAGE_KEYS = {
  ACCOUNT: "account",
  ACTIVITY: "activity",
  MANAGE_USERS: "manage_users",
  SETTINGS: "settings",
  SITE_DEVICES: "site-devices",
  SITES: "sites",
  SITE_USERS: "site-users",
  TAGS_LIST: "tags-list",
  PORTING_QUEUE: "porting-queue",
  LOA_NUMBERS: "loa-numbers-list",
  PORTING: "porting",
  CARRIER_GROUP_DETAILS: "carrier-group-details",
  LOCATION_DETAILS: "location-details",
  COMPANY_PHONE_NUMBER: "company-phone-no",
  API_SETTINGS: "api-setting",
  GLOBAL: "global",
  SYNC_LOG: "sync-log",
  MANAGE_ACCOUNTS: "manage-accounts",
  CUSTOM_FIELDS_LIST: "custom-fields-list",
};
